/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Ratingerror1Inputs */

const id_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat harus antara 1 dan 10`)
};

const ms_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penilaian mestilah antara 1 dan 10`)
};

const da_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedømmelse skal være mellem 1 og 10`)
};

const de_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Bewertung muss zwischen 1 und 10 liegen`)
};

const en_us2_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating must be between 1 and 10`)
};

const es_es2_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La valoración debe estar entre 1 y 10`)
};

const es_mx2_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La calificación debe estar entre 1 y 10`)
};

const fil_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang rating ay dapat nasa pagitan ng 1 at 10`)
};

const fr_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La note doit être comprise entre 1 et 10`)
};

const it_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La valutazione deve essere compresa tra 1 e 10`)
};

const hu_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az értékelésnek 1 és 10 között kell lennie`)
};

const nl_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beoordeling moet tussen 1 en 10 liggen`)
};

const no_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vurdering må være mellom 1 og 10`)
};

const pl_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocena musi być między 1 a 10`)
};

const pt_br2_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating must be between 1 and 10`)
};

const pt_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A classificação deve estar entre 1 e 10`)
};

const ro_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluarea trebuie să fie între 1 și 10`)
};

const fi_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arvosanan tulee olla välillä 1–10`)
};

const sv_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betyget måste vara mellan 1 och 10`)
};

const vi_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xếp hạng phải từ 1 đến 10`)
};

const tr_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puan 1 ile 10 arasında olmalıdır`)
};

const cs_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnocení musí být mezi 1 a 10`)
};

const bg_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценката трябва да бъде между 1 и 10`)
};

const ru_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценка должна быть от 1 до 10`)
};

const uk_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оцінка має бути від 1 до 10`)
};

const ar_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يجب أن يكون التقييم بين 1 و 10`)
};

const hi_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रेटिंग 1-10 के बीच होनी चाहिए`)
};

const th_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คะแนนต้องอยู่ระหว่าง 1 ถึง 10`)
};

const ja_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`評価は1から10の間でなければなりません`)
};

const zh_cn2_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating must be between 1 and 10`)
};

const zh_hant1_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating must be between 1 and 10`)
};

const ko_forms_review_ratingerror1 = /** @type {(inputs: Forms_Review_Ratingerror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating must be between 1 and 10`)
};

/**
* | output |
* | --- |
* | "Rating must be between 1 and 10" |
*
* @param {Forms_Review_Ratingerror1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_ratingerror1 = /** @type {((inputs?: Forms_Review_Ratingerror1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Ratingerror1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_ratingerror1(inputs)
	if (locale === "ms") return ms_forms_review_ratingerror1(inputs)
	if (locale === "da") return da_forms_review_ratingerror1(inputs)
	if (locale === "de") return de_forms_review_ratingerror1(inputs)
	if (locale === "en-US") return en_us2_forms_review_ratingerror1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_ratingerror1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_ratingerror1(inputs)
	if (locale === "fil") return fil_forms_review_ratingerror1(inputs)
	if (locale === "fr") return fr_forms_review_ratingerror1(inputs)
	if (locale === "it") return it_forms_review_ratingerror1(inputs)
	if (locale === "hu") return hu_forms_review_ratingerror1(inputs)
	if (locale === "nl") return nl_forms_review_ratingerror1(inputs)
	if (locale === "no") return no_forms_review_ratingerror1(inputs)
	if (locale === "pl") return pl_forms_review_ratingerror1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_ratingerror1(inputs)
	if (locale === "pt") return pt_forms_review_ratingerror1(inputs)
	if (locale === "ro") return ro_forms_review_ratingerror1(inputs)
	if (locale === "fi") return fi_forms_review_ratingerror1(inputs)
	if (locale === "sv") return sv_forms_review_ratingerror1(inputs)
	if (locale === "vi") return vi_forms_review_ratingerror1(inputs)
	if (locale === "tr") return tr_forms_review_ratingerror1(inputs)
	if (locale === "cs") return cs_forms_review_ratingerror1(inputs)
	if (locale === "bg") return bg_forms_review_ratingerror1(inputs)
	if (locale === "ru") return ru_forms_review_ratingerror1(inputs)
	if (locale === "uk") return uk_forms_review_ratingerror1(inputs)
	if (locale === "ar") return ar_forms_review_ratingerror1(inputs)
	if (locale === "hi") return hi_forms_review_ratingerror1(inputs)
	if (locale === "th") return th_forms_review_ratingerror1(inputs)
	if (locale === "ja") return ja_forms_review_ratingerror1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_ratingerror1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_ratingerror1(inputs)
	return ko_forms_review_ratingerror1(inputs)
});
export { forms_review_ratingerror1 as "forms.review.ratingError" }